<template>
  <div>
    <div class="d-flex flex-column">
      <label>{{ trans('subscription.classification_config.classification_config_modal.classification_config_name') }}</label>
      <input
        v-model="name"
        class="form-control"
      >
      <div v-if="currentBaseSelector">
        <div
          class="d-flex align-items-center py-1 mt-3 ps-3 base-selector-header-background"
        >
          <div class="fw-bold px-2">
            {{ trans('subscription.classification_config.selector_base') }}
          </div>
          <div
            class="d-flex flex-row-reverse flex-grow-1 me-3"
          >
            <button
              class="focus-style fw-bold"
              type="button"
              @click="removeBaseSelector()"
            >
              X
            </button>
          </div>
        </div>
        <SelectorBuilder
          class="ms-4 mt-1"
          :display-delete-button="false"
          :selected-selector="currentBaseSelector"
          :selector-context="selectorContext"
          :program-id="programId"
          @SaveSelector="saveBaseSelector"
        />
      </div>
      <div v-else>
        <RuleSmallButton
          :title="trans('subscription.classification_config.selector_base_add')"
          class="m-3 focus-style btn-success"
          @click.native="addBaseSelector()"
        />
        <div
          class="d-flex flex-row-reverse"
        >
          <button
            type="button"
            class="btn btn-primary"
            @click="save()"
          >
            {{ trans('core.save') }}
          </button>
          <button
            type="button"
            class="btn btn-warning me-1"
            @click="copy()"
          >
            <span class="fa fa-files-o" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectorBuilder from '@/employees/components/Selector/utilities/SelectorBuilder'
import toast from '@/services/toast'
export default {
  name: 'PreferenceConfigEditView',
  inject: ['selectorContext', 'programId'],
  components: {
    SelectorBuilder,
  },
  props: {
    currentName: {
      required: false,
      type: String,
      default: '',
    },
    preferenceNames: {
      required: true,
      type: Array,
    },
    baseSelector: {
      required: false,
      type: Object,
      default: null,
    },
  },
  data () {
    return {
      name: '',
      currentBaseSelector: null,
    }
  },
  mounted () {
    this.name = this.currentName
    if (this.baseSelector) {
      this.currentBaseSelector = { selector: this.baseSelector }
    }
  },
  methods: {
    save () {
      if (!this.duplicateName()) {
        this.$emit('Update', {
          name: this.name,
          baseSelector: undefined,
        })
      } else {
        toast.error(Lang.trans('subscription.classification_config.classification_config_modal.unique_classification_config_name'))
      }
    },
    saveBaseSelector (selector) {
      if (!this.duplicateName()) {
        this.$emit('Update', {
          name: this.name,
          baseSelector: selector,
        })
      } else {
        toast.error(Lang.trans('subscription.classification_config.classification_config_modal.unique_classification_config_name'))
      }
    },
    duplicateName () {
      if (this.currentName !== '') {
        return this.preferenceNames
          .filter(name => this.currentName.toLowerCase() !== name.toLowerCase())
          .includes(this.name.toLowerCase())
      } else {
        return this.preferenceNames
          .includes(this.name.toLowerCase())
      }
    },
    copy () {
      this.$emit('Copy')
    },
    addBaseSelector () {
      this.currentBaseSelector = { selector: null }
    },
    removeBaseSelector () {
      this.currentBaseSelector = null
    },
  },
}
</script>

<style lang="scss" scoped>
.base-selector-header-background {
  background-color: rgba(0, 0, 0, 0.3);
}
.focus-style {
  border-style: hidden;
  background: none;
  &:focus {
    border-color: #1b89ff;
    border-width: 1px;
    border-style: solid;
    box-shadow: 0 0 5px rgba(27, 137, 255, .5);
  }
}
</style>
